export const GUEST_REGISTER = "GUEST_REGISTER";
export const GUEST_REGISTER_ERROR = "GUEST_REGISTER_ERROR";
export const GUEST_REGISTER_HIDE_ERROR = "GUEST_REGISTER_HIDE_ERROR";
export const GUEST_REGISTER_START_LOADER = "GUEST_REGISTER_START_LOADER";
export const GUEST_REGISTER_STOP_LOADER = "GUEST_REGISTER_STOP_LOADER";
